import { BallPointPenAction } from '../../../core/actions/ballpoint_pen/ballpoint_pen_action';
import { LampEasySearchAction } from '../../../core/actions/lamp/lamp_search_action';
import { OrangeBookAction } from '../../../core/actions/orange_book/orange_book_action';
import { Env } from '../../../core/env';
import { TonerAction } from '../../../core/actions/toner/toner_action';
import { CategoryLlAndLAction } from '../actions/category_ll_and_l_action';

document.addEventListener('DOMContentLoaded', () => {
    CategoryLlAndLAction.init(Env);
    TonerAction.init();
    LampEasySearchAction.init();
    BallPointPenAction.init();
    OrangeBookAction.init();
});
